import { render, staticRenderFns } from "./LimitedsWithdraw.vue?vue&type=template&id=70253c02&scoped=true"
import script from "./LimitedsWithdraw.vue?vue&type=script&lang=js"
export * from "./LimitedsWithdraw.vue?vue&type=script&lang=js"
import style0 from "./LimitedsWithdraw.vue?vue&type=style&index=0&id=70253c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70253c02",
  null
  
)

export default component.exports